import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TelephoneIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TelephoneIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.3599 12.985C12.6835 12.985 12.9458 12.7227 12.9458 12.3991C12.9458 12.0754 12.6835 11.8131 12.3599 11.8131C12.0362 11.8131 11.7739 12.0754 11.7739 12.3991C11.7739 12.7227 12.0362 12.985 12.3599 12.985Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.7036 12.985C15.0272 12.985 15.2895 12.7227 15.2895 12.3991C15.2895 12.0754 15.0272 11.8131 14.7036 11.8131C14.38 11.8131 14.1177 12.0754 14.1177 12.3991C14.1177 12.7227 14.38 12.985 14.7036 12.985Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0473 12.985C17.3709 12.985 17.6333 12.7227 17.6333 12.3991C17.6333 12.0754 17.3709 11.8131 17.0473 11.8131C16.7237 11.8131 16.4614 12.0754 16.4614 12.3991C16.4614 12.7227 16.7237 12.985 17.0473 12.985Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3911 12.985C19.7147 12.985 19.977 12.7227 19.977 12.3991C19.977 12.0754 19.7147 11.8131 19.3911 11.8131C19.0675 11.8131 18.8052 12.0754 18.8052 12.3991C18.8052 12.7227 19.0675 12.985 19.3911 12.985Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.3599 15.3287C12.6835 15.3287 12.9458 15.0664 12.9458 14.7428C12.9458 14.4192 12.6835 14.1569 12.3599 14.1569C12.0362 14.1569 11.7739 14.4192 11.7739 14.7428C11.7739 15.0664 12.0362 15.3287 12.3599 15.3287Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.7036 15.3287C15.0272 15.3287 15.2895 15.0664 15.2895 14.7428C15.2895 14.4192 15.0272 14.1569 14.7036 14.1569C14.38 14.1569 14.1177 14.4192 14.1177 14.7428C14.1177 15.0664 14.38 15.3287 14.7036 15.3287Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0473 15.3287C17.3709 15.3287 17.6333 15.0664 17.6333 14.7428C17.6333 14.4192 17.3709 14.1569 17.0473 14.1569C16.7237 14.1569 16.4614 14.4192 16.4614 14.7428C16.4614 15.0664 16.7237 15.3287 17.0473 15.3287Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.3599 17.6725C12.6835 17.6725 12.9458 17.4102 12.9458 17.0865C12.9458 16.7629 12.6835 16.5006 12.3599 16.5006C12.0362 16.5006 11.7739 16.7629 11.7739 17.0865C11.7739 17.4102 12.0362 17.6725 12.3599 17.6725Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.7036 17.6725C15.0272 17.6725 15.2895 17.4102 15.2895 17.0865C15.2895 16.7629 15.0272 16.5006 14.7036 16.5006C14.38 16.5006 14.1177 16.7629 14.1177 17.0865C14.1177 17.4102 14.38 17.6725 14.7036 17.6725Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0473 17.6725C17.3709 17.6725 17.6333 17.4102 17.6333 17.0865C17.6333 16.7629 17.3709 16.5006 17.0473 16.5006C16.7237 16.5006 16.4614 16.7629 16.4614 17.0865C16.4614 17.4102 16.7237 17.6725 17.0473 17.6725Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.7739 4.78189H10.602V2.94596C10.602 2.62237 10.3397 2.36002 10.0161 2.36002H5.32861C5.00502 2.36002 4.74267 2.62236 4.74267 2.94596V4.78189H2.9458C2.62221 4.78189 2.35986 5.04423 2.35986 5.36783V19.4303C2.35986 19.7539 2.6222 20.0162 2.9458 20.0162H7.14536C7.41755 21.3519 8.60126 22.36 10.0161 22.36C11.4309 22.36 12.6146 21.3519 12.8868 20.0162H21.7739C22.0975 20.0162 22.3598 19.7539 22.3598 19.4303V5.36782C22.3598 5.04423 22.0975 4.78189 21.7739 4.78189ZM5.91455 3.53189H9.43017V16.5006H5.91455V3.53189ZM3.53174 5.95376H4.74268V17.0865C4.74268 17.4101 5.00502 17.6725 5.32862 17.6725H7.08643V18.8444H3.53175L3.53174 5.95376ZM10.0161 21.1881C9.25223 21.1881 8.60095 20.6982 8.35907 20.0162H11.6731C11.4313 20.6982 10.78 21.1881 10.0161 21.1881ZM21.188 18.8444H8.25829V17.6725H10.0161C10.3397 17.6725 10.602 17.4101 10.602 17.0865V5.95376H21.188V18.8444Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.3599 10.6412H19.3911C19.7147 10.6412 19.977 10.3789 19.977 10.0553V7.71156C19.977 7.38797 19.7147 7.12562 19.3911 7.12562H12.3599C12.0363 7.12562 11.7739 7.38796 11.7739 7.71156V10.0553C11.7739 10.3789 12.0363 10.6412 12.3599 10.6412ZM12.9458 8.2975H18.8052V9.46937H12.9458V8.2975Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3911 14.1569C19.0675 14.1569 18.8052 14.4192 18.8052 14.7428V17.0866C18.8052 17.4101 19.0675 17.6725 19.3911 17.6725C19.7147 17.6725 19.977 17.4102 19.977 17.0866V14.7428C19.977 14.4192 19.7147 14.1569 19.3911 14.1569Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TelephoneIcon;
